export interface NewsItem {
  id: string;
  title: string;
  type: string;
  date: string;
  author: string;
  summary: string;
  cover: string;
  content: string[];
}

export const newsTypes = ["新闻", "采访", "活动预告"];

export const newsItems: NewsItem[] = [
  {
    id: "n01",
    title: "2026 春季人像摄影大赛启动，百万网友投票评选年度佳作",
    type: "新闻",
    date: "2026-04-22",
    author: "编辑部",
    summary:
      "本年度春季人像摄影大赛正式开启征稿，面向所有摄影爱好者征集以「光与影」为主题的原创人像作品。",
    cover:
      "https://readdy.ai/api/search-image?query=photography%20award%20ceremony%20stage%20with%20warm%20spotlight%2C%20elegant%20minimal%20backdrop%2C%20editorial%20event%20photography%2C%20high%20detail&width=800&height=500&seq=bm-n01&orientation=landscape",
    content: [
      "备受期待的 2026 春季人像摄影大赛今日正式拉开帷幕。本届大赛以「光与影」为主题，鼓励创作者用镜头捕捉人物与光线之间最动人的关系，无论是街头抓拍还是影棚创作，都可以参与投稿。",
      "据主办方介绍，本次大赛共设置人像、街拍、写真三个单元，参赛作品将由专业评审团与网友共同投票评选。为了鼓励新人创作者，大赛还特别设立了「新锐摄影奖」，为年轻摄影师提供展示平台。",
      "征稿时间持续至五月下旬，最终获奖名单将于六月初公布。主办方表示，希望通过这样的活动让更多人关注人像摄影这一充满感染力的艺术形式。",
      "感兴趣的摄影爱好者可以关注后续的报名指引，参与这场关于光、影与美的年度盛宴。",
    ],
  },
  {
    id: "n02",
    title: "专访｜摄影师林浅：好的写真，是让人看见真实的自己",
    type: "采访",
    date: "2026-04-15",
    author: "记者 沈知",
    summary:
      "从日系写真到都市人像，摄影师林浅分享了她对于「美」的理解，以及镜头背后那些不为人知的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=photographer%20holding%20a%20camera%20in%20a%20warm%20studio%2C%20soft%20natural%20light%2C%20minimal%20neutral%20background%2C%20editorial%20portrait%2C%20high%20detail&width=800&height=500&seq=bm-n02&orientation=landscape",
    content: [
      "在与林浅的对话中，她反复提到一个词——「真实」。在她看来，最好的写真不是把人拍成想象中的样子，而是让人在镜头前卸下防备，露出最自然的松弛感。",
      "「很多人第一次拍摄会很紧张，」她笑着说，「我通常不急着按快门，先和她聊聊天，等到她自己都忘了镜头的存在，那一刻的画面才是最有生命力的。」",
      "谈及风格，林浅偏爱柔和通透的自然光。她认为光线是情绪的一部分，暖调的逆光让人温柔，清晨的窗光让人安静，而她在选择光线时，其实是在选择一种情绪的基调。",
      "对于想入门的年轻摄影师，她给出的建议很朴素：「多看、多拍、多复盘。别急着追求设备，先学会观察人。」",
    ],
  },
  {
    id: "n03",
    title: "活动预告｜「白日花园」线下写真展将于下月在美术馆开幕",
    type: "活动预告",
    date: "2026-04-09",
    author: "编辑部",
    summary:
      "以自然光为主题的线下写真展「白日花园」将于 5 月 12 日在城市美术馆开幕，展期持续三十天。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20art%20gallery%20exhibition%20space%20with%20soft%20natural%20light%2C%20white%20walls%2C%20elegant%20quiet%20atmosphere%2C%20high%20detail&width=800&height=500&seq=bm-n03&orientation=landscape",
    content: [
      "由本平台联合城市美术馆主办的线下写真展「白日花园」将于 5 月 12 日正式开幕。本次展览汇集了二十余位摄影师以自然光为主题的作品，呈现光与植物、光与人物之间的关系。",
      "展览特别设置了沉浸式光影展区，观众可以在一整面落地窗前体验不同时段光线对同一张面孔的塑造。策展人表示，希望观众不只是「看照片」，更能感受到光的存在。",
      "展期自 5 月 12 日至 6 月 10 日，每日 10:00 至 18:00 开放，周一闭馆。开幕当天将举办摄影师分享会，感兴趣的观众可提前留意预约信息。",
      "这不仅是一场展览，也是一次关于「美是如何被光创造」的公开课。",
    ],
  },
  {
    id: "n04",
    title: "行业观察：为什么越来越多品牌开始重视真实感写真",
    type: "新闻",
    date: "2026-03-30",
    author: "编辑部",
    summary:
      "过度修图的时代正在退场，带有真实质感的写真越来越受到品牌与用户的青睐，这背后是审美取向的转变。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20studio%20with%20softbox%20lighting%20and%20neutral%20background%2C%20clean%20editorial%20atmosphere%2C%20high%20detail&width=800&height=500&seq=bm-n04&orientation=landscape",
    content: [
      "过去几年，高度精修的人像一度主导了社交平台的审美。但近期多个品牌的宣传物料开始转向更自然、更真实的拍摄风格，皮肤纹理、自然光线与生活化场景成为新的关键词。",
      "业内人士分析，这种转变与用户的心理变化有关。当「完美」变得唾手可得，真实反而成为稀缺的、能建立信任的东西。带有质感与呼吸感的影像，更容易让观众产生共鸣。",
      "对摄影师而言，这也意味着技术重心从后期修图转向前期用光与沟通。如何在镜头前让被摄者放松、如何用自然光塑造立体感，成为新的基本功。",
      "可以预见，真实感与个性化将成为未来人像摄影的重要方向。",
    ],
  },
  {
    id: "n05",
    title: "采访｜街拍摄影师周野：城市的每个夜晚都有故事",
    type: "采访",
    date: "2026-03-18",
    author: "记者 陆晚",
    summary:
      "常年拍摄夜景街拍的周野，分享了他如何在城市的霓虹与光影之间，找到最动人的那一帧。",
    cover:
      "https://readdy.ai/api/search-image?query=city%20street%20at%20night%20with%20warm%20neon%20lights%20and%20reflections%2C%20cinematic%20urban%20atmosphere%2C%20high%20detail&width=800&height=500&seq=bm-n05&orientation=landscape",
    content: [
      "周野的相机里装着上百个夜晚。他习惯在日落后出门，沿着城市的主干道慢慢走，等待光线与人群交汇的那个瞬间。",
      "「夜景最难的是控制光，」他说，「霓虹太杂，容易把画面弄脏。我的办法是找到一个主光源，让其他光都变成围绕它的层次。」",
      "谈到被摄者，周野更偏爱抓拍。「我不太喜欢让人摆姿势，真实的动作往往比设计过的更打动人。」在他眼里，街拍的魅力就在于不可复制。",
      "他希望有一天能出一本关于这座城市的夜拍影集，「把那些一闪而过的瞬间留下来」。",
    ],
  },
  {
    id: "n06",
    title: "活动预告｜新人摄影师扶持计划开启报名，提供免费影棚档期",
    type: "活动预告",
    date: "2026-03-05",
    author: "编辑部",
    summary:
      "面向新锐摄影师的扶持计划正式开启，入选者将获得免费影棚档期与导师一对一指导机会。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20professional%20photo%20studio%20with%20lighting%20equipment%2C%20minimal%20neutral%20interior%2C%20soft%20warm%20tone%2C%20high%20detail&width=800&height=500&seq=bm-n06&orientation=landscape",
    content: [
      "为了帮助新锐摄影师成长，本平台正式启动年度新人扶持计划。凡拍摄经验在三年以内、有独立作品集的创作者均可报名参与。",
      "入选者将获得为期一个月的免费影棚档期，并有机会与资深摄影师进行一对一的创作指导。主办方还将为其作品提供线上展示与推广资源。",
      "「我们希望能给真正热爱摄影的年轻人一点实实在在的支持，」项目负责人表示，「不只是曝光，更是让他们有空间去把想法拍出来。」",
      "报名通道已正式开放，具体细则可留意后续公告。",
    ],
  },
];